import { Flex, Text } from '@/src/ui-components';
import { AlertCircle } from 'lucide-react';
import { ErrorResponse } from 'xrpl';

export const PathFindingError = ({ error }: { error: ErrorResponse }) => {
  return (
    <Flex
      align="center"
      gap={2}
      className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 dark:border-red-800 dark:bg-red-900/20"
    >
      <AlertCircle size={16} className="text-red-600 dark:text-red-400" />
      <Text size="sm" className="text-red-800 dark:text-red-200">
        Error finding payment path: {error.error_message}
      </Text>
    </Flex>
  );
};
